import * as i0 from '@angular/core';
import { EventEmitter, booleanAttribute, Component, ViewEncapsulation, ViewChild, Input, Output, ContentChild, Injectable, NgModule } from '@angular/core';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i1$1 from '@angular/material/snack-bar';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import * as i2$2 from '@angular/material/progress-bar';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import * as i1 from '@angular/material/dialog';
import { MatDialogModule } from '@angular/material/dialog';
import * as i4 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import { of, throwError, merge } from 'rxjs';
import * as i2$1 from '@angular/platform-browser';
import { tap, take } from 'rxjs/operators';
import { trigger, state, style, transition, animate } from '@angular/animations';
const _c0 = ["modalTemp"];
const _c1 = ["*"];
function TmModalComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
const _c2 = ["tmModalHeader"];
function TmModalHeaderComponent_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 3);
    i0.ɵɵlistener("click", function TmModalHeaderComponent_button_1_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.modal.close(ctx_r1.modal.CLOSE_REASON.CLOSE));
    });
    i0.ɵɵelementStart(1, "span", 4);
    i0.ɵɵtext(2, "\xD7");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵattribute("aria-label", ctx_r1.modal.closeBtnAriaLabel);
  }
}
function TmModalHeaderComponent_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "h1", 5);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.modal.title);
  }
}
const _c3 = ["tmModalBody"];
function TmModalBodyComponent_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "p");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.modal.message);
  }
}
const _c4 = ["tmModalFooter"];
function TmModalFooterComponent_ng_container_2_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 4);
    i0.ɵɵlistener("click", function TmModalFooterComponent_ng_container_2_button_1_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.modal.close(ctx_r1.modal.CLOSE_REASON.CLOSE));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.modal.cancelBtnLabel);
  }
}
function TmModalFooterComponent_ng_container_2_button_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 5);
    i0.ɵɵlistener("click", function TmModalFooterComponent_ng_container_2_button_2_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.modal.close(ctx_r1.modal.CLOSE_REASON.SUBMIT));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.modal.okBtnLabel);
  }
}
function TmModalFooterComponent_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, TmModalFooterComponent_ng_container_2_button_1_Template, 2, 1, "button", 2)(2, TmModalFooterComponent_ng_container_2_button_2_Template, 2, 1, "button", 3);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.modal.cancelBtnLabel);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.modal.okBtnLabel);
  }
}
function ErrorAlertComponent_button_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 5);
    i0.ɵɵlistener("click", function ErrorAlertComponent_button_8_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      const tip_r4 = i0.ɵɵreference(7);
      return i0.ɵɵresetView(ctx_r2.copyTip(tip_r4));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r2.copyBtnLabel);
  }
}
function IndeterminateProgressBarComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelement(1, "mat-progress-bar", 2);
    i0.ɵɵelementEnd();
  }
}
class TmModalData {
  /** 彈窗表頭標題 */
  title = '';
  /** 彈窗內文 */
  content = '';
  /** 彈窗關閉按鈕標籤 */
  cancelBtnLabel = 'CANCEL';
  /** 彈窗開啟按鈕標籤 */
  okBtnLabel = 'OK';
  /** 是否顯示彈窗表頭上的關閉叉叉按鈕 */
  showClose = true;
  constructor(param) {
    if (!param) {
      return this;
    }
    if (typeof param.showClose === 'boolean') {
      this.showClose = param.showClose;
    }
    if (param.okBtnLabel) {
      this.okBtnLabel = param.okBtnLabel;
    }
    if (param.cancelBtnLabel) {
      this.cancelBtnLabel = param.cancelBtnLabel;
    }
    if (param.content) {
      this.content = param.content;
    }
    if (param.title) {
      this.title = param.title;
    }
    return this;
  }
}
var TmModalCloseReason = /*#__PURE__*/function (TmModalCloseReason) {
  TmModalCloseReason[TmModalCloseReason["SUBMIT"] = 0] = "SUBMIT";
  TmModalCloseReason[TmModalCloseReason["CLOSE"] = 1] = "CLOSE";
  return TmModalCloseReason;
}(TmModalCloseReason || {});
let TmModalComponent = /*#__PURE__*/(() => {
  class TmModalComponent {
    dialog;
    CLOSE_REASON = TmModalCloseReason;
    modalTemp;
    // @ContentChild(TmModalHeaderComponent, {static: true}) headerTemp: TmModalHeaderComponent;
    // @ContentChild(TmModalBodyComponent, {static: true}) bodyTemp: TmModalBodyComponent;
    // @ContentChild(TmModalFooterComponent, {static: true}) footerTemp: TmModalFooterComponent;
    _modalConfig = {
      width: '600px',
      position: {
        top: '5%'
      },
      maxHeight: '90%',
      panelClass: ['tm-modal'],
      closeOnNavigation: true,
      restoreFocus: true,
      autoFocus: true,
      data: new TmModalData({
        okBtnLabel: '確認',
        cancelBtnLabel: '取消'
      })
    };
    /** 彈窗設定
     * https://v16.material.angular.io/components/dialog/api#MatDialogConfig
     */
    set modalConfig(cnf) {
      if (cnf) {
        if (cnf.panelClass && cnf.panelClass.length > 0) {
          this.panelClass = cnf.panelClass;
          delete cnf.panelClass;
        }
        Object.assign(this._modalConfig, cnf);
      }
    }
    get modalConfig() {
      return this._modalConfig;
    }
    /** 自訂義彈窗的 css 類 */
    set panelClass(c) {
      if (!c || c.length === 0) {
        if (this.panelClass.length > 1) {
          this.panelClass.splice(0, this.panelClass.length - 1);
        }
        return;
      }
      this._modalConfig.panelClass = this.panelClass.concat(c);
    }
    get panelClass() {
      return this._modalConfig.panelClass;
    }
    get data() {
      return this._modalConfig.data;
    }
    /** 表頭標題 */
    set title(s) {
      if (!this.data) {
        return;
      }
      if (s) {
        this.data.title = s;
      } else if (this.data.title) {
        this.data.title = '';
      }
    }
    get title() {
      return this.data?.title || '';
    }
    /** 主內文 */
    set message(s) {
      if (!this.data) {
        return;
      }
      if (s) {
        this.data.content = s;
      } else if (this.data.content) {
        this.data.content = '';
      }
    }
    get message() {
      return this.data?.content || '';
    }
    /** 確認按鈕標籤 */
    set okBtnLabel(s) {
      if (!this.data) {
        return;
      }
      if (s) {
        this.data.okBtnLabel = s;
      } else if (this.data.okBtnLabel) {
        this.data.okBtnLabel = '';
      }
    }
    get okBtnLabel() {
      return this.data?.okBtnLabel || '';
    }
    /** 取消按鈕標籤 */
    set cancelBtnLabel(s) {
      if (!this.data) {
        return;
      }
      if (s) {
        this.data.cancelBtnLabel = s;
      } else if (this.data.cancelBtnLabel) {
        this.data.cancelBtnLabel = '';
      }
    }
    get cancelBtnLabel() {
      return this.data?.cancelBtnLabel || '';
    }
    /** 是否顯示表頭的關閉叉叉按鈕 */
    set showClose(b) {
      if (!this.data) {
        return;
      }
      if (b !== undefined && b !== null) {
        this.data.showClose = b;
      }
    }
    get showClose() {
      return this.data?.showClose || false;
    }
    /** 顯示於表頭的關閉叉叉按鈕語意標籤 */
    closeBtnAriaLabel = 'Close';
    /** 確認後關閉事件完成 */
    afterConfirm = new EventEmitter();
    /** 非確認關閉事件完成 */
    afterCancel = new EventEmitter();
    mdRef;
    isOpened = false;
    constructor(dialog) {
      this.dialog = dialog;
    }
    open() {
      this.mdRef = this.dialog.open(this.modalTemp, this.modalConfig);
      this.isOpened = true;
      this.listenAfterCloseEvent();
      return this.mdRef.afterOpened();
    }
    listenAfterCloseEvent() {
      if (!this.mdRef) {
        return;
      }
      this.mdRef.afterClosed().subscribe(v => {
        this.isOpened = false;
        switch (v) {
          case TmModalCloseReason.SUBMIT:
            this.afterConfirm.emit();
            break;
          case TmModalCloseReason.CLOSE:
            this.afterCancel.emit();
            break;
          default:
            // undefined, from backdrop click.
            this.afterCancel.emit();
            break;
        }
      });
    }
    close(reason = TmModalCloseReason.CLOSE) {
      if (!this.mdRef) {
        return of(undefined);
      }
      this.mdRef.close(reason);
      return this.mdRef.afterClosed();
    }
    static ɵfac = function TmModalComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TmModalComponent)(i0.ɵɵdirectiveInject(i1.MatDialog));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: TmModalComponent,
      selectors: [["tm-modal"]],
      viewQuery: function TmModalComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0, 7);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.modalTemp = _t.first);
        }
      },
      inputs: {
        modalConfig: "modalConfig",
        panelClass: "panelClass",
        title: "title",
        message: "message",
        okBtnLabel: "okBtnLabel",
        cancelBtnLabel: "cancelBtnLabel",
        showClose: [2, "showClose", "showClose", booleanAttribute],
        closeBtnAriaLabel: "closeBtnAriaLabel"
      },
      outputs: {
        afterConfirm: "afterConfirm",
        afterCancel: "afterCancel"
      },
      exportAs: ["tmModal"],
      features: [i0.ɵɵInputTransformsFeature],
      ngContentSelectors: _c1,
      decls: 2,
      vars: 0,
      consts: [["modalTemp", ""]],
      template: function TmModalComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵtemplate(0, TmModalComponent_ng_template_0_Template, 1, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        }
      },
      styles: [".tm-modal .mat-dialog-container{padding:0}\n"],
      encapsulation: 2
    });
  }
  return TmModalComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TmModalHeaderComponent = /*#__PURE__*/(() => {
  class TmModalHeaderComponent {
    modal;
    headerTemp;
    constructor(modal) {
      this.modal = modal;
    }
    static ɵfac = function TmModalHeaderComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TmModalHeaderComponent)(i0.ɵɵdirectiveInject(TmModalComponent));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: TmModalHeaderComponent,
      selectors: [["tm-modal-header"]],
      contentQueries: function TmModalHeaderComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, _c2, 7);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerTemp = _t.first);
        }
      },
      ngContentSelectors: _c1,
      decls: 4,
      vars: 2,
      consts: [[1, "tm-modal-header"], ["class", "tm-modal-close", "type", "button", 3, "click", 4, "ngIf"], [4, "ngIf"], ["type", "button", 1, "tm-modal-close", 3, "click"], ["aria-hidden", "true"], ["mat-dialog-title", "", 1, "tm-modal-title"]],
      template: function TmModalHeaderComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵtemplate(1, TmModalHeaderComponent_button_1_Template, 3, 1, "button", 1);
          i0.ɵɵprojection(2, 0, ["#customTemp", ""]);
          i0.ɵɵtemplate(3, TmModalHeaderComponent_ng_container_3_Template, 3, 1, "ng-container", 2);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.modal.showClose);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", !ctx.headerTemp);
        }
      },
      dependencies: [i2.NgIf, i1.MatDialogTitle],
      styles: [".mat-dialog-title.tm-modal-title{margin:0}.tm-modal-header{padding:15px;border-bottom:1px solid #e5e5e5}.tm-modal-close{float:right;font-size:2rem;font-weight:700;line-height:1;color:#000;text-shadow:0 1px 0 #fff;filter:alpha(opacity=20);opacity:.2;-webkit-appearance:none;padding:0;cursor:pointer;background:0 0;border:0;margin-top:-2px;position:relative;z-index:1}.tm-modal-close:focus,.tm-modal-close:hover{color:#000;text-decoration:none;cursor:pointer;filter:alpha(opacity=50);opacity:.5}\n"],
      encapsulation: 2
    });
  }
  return TmModalHeaderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TmModalBodyComponent = /*#__PURE__*/(() => {
  class TmModalBodyComponent {
    modal;
    bodyTemp;
    constructor(modal) {
      this.modal = modal;
    }
    static ɵfac = function TmModalBodyComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TmModalBodyComponent)(i0.ɵɵdirectiveInject(TmModalComponent));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: TmModalBodyComponent,
      selectors: [["tm-modal-body"]],
      contentQueries: function TmModalBodyComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, _c3, 7);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.bodyTemp = _t.first);
        }
      },
      ngContentSelectors: _c1,
      decls: 3,
      vars: 1,
      consts: [["mat-dialog-content", "", 1, "tm-modal-body"], [4, "ngIf"]],
      template: function TmModalBodyComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵprojection(1, 0, ["#customTemp", ""]);
          i0.ɵɵtemplate(2, TmModalBodyComponent_ng_container_2_Template, 3, 1, "ng-container", 1);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", !ctx.bodyTemp);
        }
      },
      dependencies: [i2.NgIf, i1.MatDialogContent],
      styles: [".mat-dialog-content.tm-modal-body{margin:0;padding:15px}\n"],
      encapsulation: 2
    });
  }
  return TmModalBodyComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TmModalFooterComponent = /*#__PURE__*/(() => {
  class TmModalFooterComponent {
    modal;
    footerTemp;
    constructor(modal) {
      this.modal = modal;
    }
    static ɵfac = function TmModalFooterComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TmModalFooterComponent)(i0.ɵɵdirectiveInject(TmModalComponent));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: TmModalFooterComponent,
      selectors: [["tm-modal-footer"]],
      contentQueries: function TmModalFooterComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, _c4, 7);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.footerTemp = _t.first);
        }
      },
      ngContentSelectors: _c1,
      decls: 3,
      vars: 1,
      consts: [["mat-dialog-actions", "", "align", "end", 1, "tm-modal-footer"], [4, "ngIf"], ["type", "button", "mat-stroked-button", "", 3, "click", 4, "ngIf"], ["type", "button", "mat-stroked-button", "", "cdkFocusInitial", "", 3, "click", 4, "ngIf"], ["type", "button", "mat-stroked-button", "", 3, "click"], ["type", "button", "mat-stroked-button", "", "cdkFocusInitial", "", 3, "click"]],
      template: function TmModalFooterComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵprojection(1, 0, ["#customTemp", ""]);
          i0.ɵɵtemplate(2, TmModalFooterComponent_ng_container_2_Template, 3, 2, "ng-container", 1);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", !ctx.footerTemp);
        }
      },
      dependencies: [i2.NgIf, i1.MatDialogActions, i4.MatButton],
      styles: [".mat-dialog-actions.tm-modal-footer{margin-bottom:0;padding:15px}.tm-modal-footer{padding:15px;text-align:right;border-top:1px solid #e5e5e5}\n"],
      encapsulation: 2
    });
  }
  return TmModalFooterComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let InfoConfirmComponent = /*#__PURE__*/(() => {
  class InfoConfirmComponent {
    dialog;
    sanitizer;
    modal;
    /** 表頭標題，預設為"INFO Confirm" */
    title = 'INFO Confirm';
    /** 主內文，可以塞入 HTML 標記語法 */
    _message = '';
    /** 主內文 */
    safeMessage;
    /** 主內文，可以塞入 HTML 標記語法 */
    set message(s) {
      if (s) {
        this._message = s;
        this.safeMessage = this.sanitizer.bypassSecurityTrustHtml(this.message);
      } else if (this._message) {
        delete this._message;
        delete this.safeMessage;
      }
    }
    /** 主內文，可以塞入 HTML 標記語法 */
    get message() {
      return this._message || '';
    }
    /** 確認按鈕標籤，預設為"確認" */
    okBtnLabel = '確認';
    /** 取消按鈕標籤，預設為"取消" */
    cancelBtnLabel = '取消';
    /** 自訂義彈窗的 css 類，預設為"info-confirm-modal" */
    panelClass = ['info-confirm-modal'];
    /** 彈窗設定
     * https://v12.material.angular.io/components/dialog/api#MatDialogConfig
     */
    modalConfig;
    /** 確認後關閉事件完成 */
    afterConfirm = new EventEmitter();
    /** 非確認關閉事件完成 */
    afterCancel = new EventEmitter();
    constructor(dialog, sanitizer) {
      this.dialog = dialog;
      this.sanitizer = sanitizer;
    }
    open() {
      if (!this.modal) {
        return throwError('Modal not ready');
      }
      if (this.modal.isOpened) {
        console.error('Coding error! Already opened, You should manually close opened dialog, or use ReusableInfoConfirmComponent');
      }
      return this.modal.open();
    }
    close() {
      if (!this.modal) {
        return throwError('Modal not ready');
      }
      return this.modal.close();
    }
    static ɵfac = function InfoConfirmComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || InfoConfirmComponent)(i0.ɵɵdirectiveInject(i1.MatDialog), i0.ɵɵdirectiveInject(i2$1.DomSanitizer));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: InfoConfirmComponent,
      selectors: [["tm-info-confirm"]],
      viewQuery: function InfoConfirmComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(TmModalComponent, 7);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.modal = _t.first);
        }
      },
      inputs: {
        title: "title",
        message: "message",
        okBtnLabel: "okBtnLabel",
        cancelBtnLabel: "cancelBtnLabel",
        panelClass: "panelClass",
        modalConfig: "modalConfig"
      },
      outputs: {
        afterConfirm: "afterConfirm",
        afterCancel: "afterCancel"
      },
      decls: 6,
      vars: 7,
      consts: [["tmModalBody", ""], [3, "afterConfirm", "afterCancel", "title", "message", "okBtnLabel", "cancelBtnLabel", "panelClass", "modalConfig"], [2, "white-space", "pre-line", 3, "innerHTML"]],
      template: function InfoConfirmComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵelementStart(0, "tm-modal", 1);
          i0.ɵɵlistener("afterConfirm", function InfoConfirmComponent_Template_tm_modal_afterConfirm_0_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.afterConfirm.emit());
          })("afterCancel", function InfoConfirmComponent_Template_tm_modal_afterCancel_0_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.afterCancel.emit());
          });
          i0.ɵɵelement(1, "tm-modal-header");
          i0.ɵɵelementStart(2, "tm-modal-body");
          i0.ɵɵelement(3, "p", 2, 0);
          i0.ɵɵelementEnd();
          i0.ɵɵelement(5, "tm-modal-footer");
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("title", ctx.title)("message", ctx.message)("okBtnLabel", ctx.okBtnLabel)("cancelBtnLabel", ctx.cancelBtnLabel)("panelClass", ctx.panelClass)("modalConfig", ctx.modalConfig);
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("innerHTML", ctx.safeMessage, i0.ɵɵsanitizeHtml);
        }
      },
      dependencies: [TmModalComponent, TmModalHeaderComponent, TmModalBodyComponent, TmModalFooterComponent],
      styles: [".info-confirm-modal .tm-modal-header{background:#a6b9f2}.info-confirm-modal .tm-modal-body{word-break:break-all}\n"],
      encapsulation: 2
    });
  }
  return InfoConfirmComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let InfoAlertComponent = /*#__PURE__*/(() => {
  class InfoAlertComponent extends InfoConfirmComponent {
    /** 表頭標題，預設為"INFO" */
    title = 'INFO';
    /** 確認按鈕標籤 */
    okBtnLabel = '';
    modalConfig = {
      role: 'alertdialog',
      hasBackdrop: false
    };
    /** 自訂義彈窗的 css 類，預設為"info-alert-modal" */
    panelClass = ['info-alert-modal'];
    static ɵfac = /* @__PURE__ */(() => {
      let ɵInfoAlertComponent_BaseFactory;
      return function InfoAlertComponent_Factory(__ngFactoryType__) {
        return (ɵInfoAlertComponent_BaseFactory || (ɵInfoAlertComponent_BaseFactory = i0.ɵɵgetInheritedFactory(InfoAlertComponent)))(__ngFactoryType__ || InfoAlertComponent);
      };
    })();
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: InfoAlertComponent,
      selectors: [["tm-info-alert"]],
      inputs: {
        title: "title",
        panelClass: "panelClass"
      },
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 6,
      vars: 7,
      consts: [["tmModalBody", ""], [3, "afterConfirm", "afterCancel", "title", "message", "okBtnLabel", "cancelBtnLabel", "panelClass", "modalConfig"], [2, "white-space", "pre-line", 3, "innerHTML"]],
      template: function InfoAlertComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵelementStart(0, "tm-modal", 1);
          i0.ɵɵlistener("afterConfirm", function InfoAlertComponent_Template_tm_modal_afterConfirm_0_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.afterConfirm.emit());
          })("afterCancel", function InfoAlertComponent_Template_tm_modal_afterCancel_0_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.afterCancel.emit());
          });
          i0.ɵɵelement(1, "tm-modal-header");
          i0.ɵɵelementStart(2, "tm-modal-body");
          i0.ɵɵelement(3, "p", 2, 0);
          i0.ɵɵelementEnd();
          i0.ɵɵelement(5, "tm-modal-footer");
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("title", ctx.title)("message", ctx.message)("okBtnLabel", ctx.okBtnLabel)("cancelBtnLabel", ctx.cancelBtnLabel)("panelClass", ctx.panelClass)("modalConfig", ctx.modalConfig);
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("innerHTML", ctx.safeMessage, i0.ɵɵsanitizeHtml);
        }
      },
      dependencies: [TmModalComponent, TmModalHeaderComponent, TmModalBodyComponent, TmModalFooterComponent],
      styles: [".info-alert-modal .tm-modal-header{background:#ccf2a6}.info-alert-modal .tm-modal-body{word-break:break-all}\n"],
      encapsulation: 2
    });
  }
  return InfoAlertComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ErrorAlertComponent = /*#__PURE__*/(() => {
  class ErrorAlertComponent extends InfoAlertComponent {
    /** 表頭標題，預設為"ERROR" */
    title = 'ERROR';
    /** 確認按鈕標籤 */
    okBtnLabel = '';
    /** 自訂義彈窗的 css 類，預設為"error-alert-modal" */
    panelClass = ['error-alert-modal'];
    /** 是否顯示複製錯誤提示訊息到剪貼簿按鈕 */
    showCopyButton = false;
    /** 複製錯誤提示訊息到剪貼簿按鈕的標籤文字，預設為"Copy to clipboard"  */
    copyBtnLabel = 'Copy to clipboard';
    /** 複製錯誤提示訊息到剪貼簿 */
    copyTip(targetEl) {
      window.getSelection()?.selectAllChildren(targetEl);
      document.execCommand('Copy');
    }
    static ɵfac = /* @__PURE__ */(() => {
      let ɵErrorAlertComponent_BaseFactory;
      return function ErrorAlertComponent_Factory(__ngFactoryType__) {
        return (ɵErrorAlertComponent_BaseFactory || (ɵErrorAlertComponent_BaseFactory = i0.ɵɵgetInheritedFactory(ErrorAlertComponent)))(__ngFactoryType__ || ErrorAlertComponent);
      };
    })();
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ErrorAlertComponent,
      selectors: [["tm-error-alert"]],
      inputs: {
        title: "title",
        panelClass: "panelClass",
        showCopyButton: "showCopyButton",
        copyBtnLabel: "copyBtnLabel"
      },
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 10,
      vars: 8,
      consts: [["tmModalBody", ""], ["tmModalBody", "", "tip", ""], [3, "afterConfirm", "afterCancel", "title", "message", "okBtnLabel", "cancelBtnLabel", "panelClass", "modalConfig"], [2, "white-space", "pre-line", 3, "innerHTML"], ["type", "button", 3, "click", 4, "ngIf"], ["type", "button", 3, "click"]],
      template: function ErrorAlertComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵelementStart(0, "tm-modal", 2);
          i0.ɵɵlistener("afterConfirm", function ErrorAlertComponent_Template_tm_modal_afterConfirm_0_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.afterConfirm.emit());
          })("afterCancel", function ErrorAlertComponent_Template_tm_modal_afterCancel_0_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.afterCancel.emit());
          });
          i0.ɵɵelement(1, "tm-modal-header");
          i0.ɵɵelementStart(2, "tm-modal-body")(3, "div", null, 0);
          i0.ɵɵelement(5, "p", 3, 1);
          i0.ɵɵtemplate(8, ErrorAlertComponent_button_8_Template, 2, 1, "button", 4);
          i0.ɵɵelementEnd()();
          i0.ɵɵelement(9, "tm-modal-footer");
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("title", ctx.title)("message", ctx.message)("okBtnLabel", ctx.okBtnLabel)("cancelBtnLabel", ctx.cancelBtnLabel)("panelClass", ctx.panelClass)("modalConfig", ctx.modalConfig);
          i0.ɵɵadvance(5);
          i0.ɵɵproperty("innerHTML", ctx.safeMessage, i0.ɵɵsanitizeHtml);
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("ngIf", ctx.showCopyButton);
        }
      },
      dependencies: [i2.NgIf, TmModalComponent, TmModalHeaderComponent, TmModalBodyComponent, TmModalFooterComponent],
      styles: [".error-alert-modal .tm-modal-header{background:#f2a6a6}.error-alert-modal .tm-modal-body{word-break:break-all}\n"],
      encapsulation: 2
    });
  }
  return ErrorAlertComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IndeterminateProgressBarComponent = /*#__PURE__*/(() => {
  class IndeterminateProgressBarComponent {
    isShow = false;
    constructor() {}
    ngOnInit() {}
    show() {
      this.isShow = true;
    }
    hide() {
      this.isShow = false;
    }
    static ɵfac = function IndeterminateProgressBarComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IndeterminateProgressBarComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IndeterminateProgressBarComponent,
      selectors: [["tm-indeterminate-progress-bar"]],
      decls: 1,
      vars: 1,
      consts: [["class", "indeterminate", 4, "ngIf"], [1, "indeterminate"], ["mode", "indeterminate"]],
      template: function IndeterminateProgressBarComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, IndeterminateProgressBarComponent_div_0_Template, 2, 0, "div", 0);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", ctx.isShow);
        }
      },
      dependencies: [i2.NgIf, i2$2.MatProgressBar],
      styles: [".indeterminate{position:fixed;top:0;left:0;width:100%;z-index:9999}\n"],
      encapsulation: 2
    });
  }
  return IndeterminateProgressBarComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** @techmore/global 組件的調用方法 */
let GlobalComponentService = /*#__PURE__*/(() => {
  class GlobalComponentService {
    snackBar;
    /** 放置 global 組件的宿主組件，需在宿主中註冊進此屬性中 */
    globalCmp;
    /** 進度條調用者註冊機 */
    processingRegister = [];
    /** 進度條是否顯示中 */
    isProgessBarOpening = false;
    constructor(snackBar) {
      this.snackBar = snackBar;
    }
    /**
     * 跳出警告訊息彈出視窗
     * @param message 訊息內容，可塞HTML字串
     * @param param title: 彈出視窗標題，若未帶入則使用預設值；afterClose 彈出視窗關閉後的回調函式
     */
    openInfoAlert(message, param) {
      if (!this.globalCmp) {
        throw new Error('globalCmp not ready');
      }
      return this.globalCmp.openInfoAlert(message, param);
    }
    /**
     * 跳出訊息確認彈出視窗
     * @param message 訊息內容，可塞HTML字串
     * @param param title: 彈出視窗標題，若未帶入則使用預設值；afterConfirm: 點擊確認按鈕後的回調涵式；afterClose 彈出視窗(不是點確認按鈕)關閉後的回調函式
     */
    openInfoConfirm(message, param) {
      if (!this.globalCmp) {
        throw new Error('globalCmp not ready');
      }
      return this.globalCmp.openInfoConfirm(message, param);
    }
    /**
     * 跳出錯誤訊息彈出視窗
     * @param message 訊息內容，可塞HTML字串
     * @param param title: 彈出視窗標題，若未帶入則使用預設值；afterClose 彈出視窗關閉後的回調函式；showCopyTip: 是否顯示複製到剪貼簿按鈕，預設為不顯示
     */
    openErrorAlert(message, param) {
      if (!this.globalCmp) {
        throw new Error('globalCmp not ready');
      }
      return this.globalCmp.openErrorAlert(message, param);
    }
    /** 顯示進度條，返還一個 uuid，關閉時需代入 */
    openIndeterminateProgressBar() {
      if (!this.globalCmp) {
        throw new Error('globalCmp not ready');
      }
      const uuid = _uuid();
      this.processingRegister.push(uuid);
      if (!this.isProgessBarOpening) {
        this.isProgessBarOpening = true;
        if (this.globalCmp) this.globalCmp.openIndeterminateProgressBar();
      }
      return uuid;
    }
    /** 關閉進度條顯示。帶入開啟時返還的 uuid，如果還有未告知結束的進度則進度條不關閉；不帶入 uuid 則清空所有已註冊的進度並關閉進度條 */
    closeIndeterminateProgressBar(uuid) {
      if (!this.globalCmp) {
        throw new Error('globalCmp not ready');
      }
      if (!this.isProgessBarOpening) {
        return;
      }
      if (uuid) {
        const fidx = this.processingRegister.findIndex(s => s === uuid);
        if (fidx !== -1) {
          this.processingRegister.splice(fidx, 1);
        }
        if (!this.processingRegister.length) {
          this.isProgessBarOpening = false;
          if (this.globalCmp) this.globalCmp.closeIndeterminateProgressBar();
        }
      } else {
        this.isProgessBarOpening = false;
        if (this.globalCmp) this.globalCmp.closeIndeterminateProgressBar();
        this.processingRegister = [];
      }
    }
    /**
     * Opens a snackbar with a message and an optional action.
     * @param message — The message to show in the snackbar.
     * @param action — The label for the snackbar action，defult is X.
     * @param config — [Additional configuration options](https://v8.material.angular.io/components/snack-bar/api#MatSnackBarConfig) for the snackbar, with default duration 1600 ms.
     */
    openSanckBar(message, action = 'X', config) {
      // if (this.globalCmp ) this.globalCmp.openSanckBar(message, action, { duration: 1600, });
      const _cfg = {
        duration: 1600,
        ...config
      };
      this.snackBar.open(message, action, _cfg);
    }
    /** 關閉短語回饋 */
    closeSnackBar() {
      this.snackBar.dismiss();
    }
    static ɵfac = function GlobalComponentService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GlobalComponentService)(i0.ɵɵinject(i1$1.MatSnackBar));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: GlobalComponentService,
      factory: GlobalComponentService.ɵfac
    });
  }
  return GlobalComponentService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/** 產生 uuid。從 https://www.cythilya.tw/2017/03/12/uuid/ 參考 */
function _uuid() {
  let d = Date.now();
  if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
    d += performance.now(); // use high-precision timer if available
  }
  // tslint:disable-next-line: only-arrow-functions
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    // tslint:disable-next-line: no-bitwise
    const r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
  });
}

/**
 * 組件可重用，只建立一個確認窗口透過服務更改顯示內容，
 * 開啟重用會在未關閉確認窗時暫存所有接收到且未關閉的訊息，並在點選關閉後播放堆線中下一個訊息
 *
 * 所有參數綁定和事件拋出是間皆是引用自實體的訊息確認窗
 */
let ReusableInfoConfirmComponent = /*#__PURE__*/(() => {
  class ReusableInfoConfirmComponent {
    _infoConfirm;
    /** 實體的訊息確認窗 */
    set infoConfirm(c) {
      if (c) {
        this._infoConfirm = c;
        this.setPendingDatas();
      }
    }
    get infoConfirm() {
      return this._infoConfirm;
    }
    _pendingTitle;
    /** 表頭標題 */
    set title(t) {
      if (this.infoConfirm) {
        this.infoConfirm.title = t;
        this._pendingTitle = undefined;
      } else {
        this._pendingTitle = t;
      }
    }
    get title() {
      if (this.infoConfirm) {
        return this.infoConfirm.title;
      }
      return this._pendingTitle || '';
    }
    _pendingMessage;
    /** 主內文 */
    set message(m) {
      if (this.infoConfirm) {
        this.infoConfirm.message = m;
        this._pendingMessage = undefined;
      } else {
        this._pendingMessage = m;
      }
    }
    get message() {
      if (this.infoConfirm) {
        return this.infoConfirm.message;
      }
      return this._pendingMessage || '';
    }
    _pendingOkBtnLabel;
    /** 確認按鈕標籤 */
    set okBtnLabel(ol) {
      if (this.infoConfirm) {
        this.infoConfirm.okBtnLabel = ol;
        this._pendingOkBtnLabel = undefined;
      } else {
        this._pendingOkBtnLabel = ol;
      }
    }
    get okBtnLabel() {
      if (this.infoConfirm) {
        return this.infoConfirm.okBtnLabel;
      }
      return this._pendingOkBtnLabel || '';
    }
    _pendingCancelBtnLabel;
    /** 取消按鈕標籤 */
    set cancelBtnLabel(cl) {
      if (this.infoConfirm) {
        this.infoConfirm.cancelBtnLabel = cl;
        this._pendingCancelBtnLabel = undefined;
      } else {
        this._pendingCancelBtnLabel = cl;
      }
    }
    get cancelBtnLabel() {
      if (this.infoConfirm) {
        return this.infoConfirm.cancelBtnLabel;
      }
      return this._pendingCancelBtnLabel || '';
    }
    _pendingPanelClass;
    /** 自訂義彈窗的 css 類 */
    set panelClass(pc) {
      if (this.infoConfirm) {
        this.infoConfirm.panelClass = pc;
        this._pendingPanelClass = undefined;
      } else {
        this._pendingPanelClass = pc;
      }
    }
    get panelClass() {
      if (this.infoConfirm) {
        return this.infoConfirm.panelClass;
      }
      return this._pendingPanelClass || [];
    }
    _pendingModalConfig;
    /** 彈窗設定
     * https://v12.material.angular.io/components/dialog/api#MatDialogConfig
     */
    set modalConfig(c) {
      if (this.infoConfirm) {
        this.infoConfirm.modalConfig = c;
        this._pendingModalConfig = undefined;
      } else {
        this._pendingModalConfig = c;
      }
    }
    get modalConfig() {
      if (this.infoConfirm) {
        return this.infoConfirm.modalConfig || {};
      }
      return this._pendingModalConfig || {};
    }
    /** 確認後關閉事件完成 */
    afterConfirm = new EventEmitter();
    /** 非確認關閉事件完成 */
    afterCancel = new EventEmitter();
    cachedInfos = [];
    open(message, param) {
      if (this.isSameWithLastest(message, param)) {
        return;
      }
      const cached = {
        message: message,
        param: param
      };
      this.cachedInfos.push(cached);
      const cIndex = this.cachedInfos.length - 1;
      this.setInfo(cached, cIndex);
      if (this.infoConfirm && this.infoConfirm.modal && !this.infoConfirm.modal.isOpened) {
        this.infoConfirm.open();
      }
    }
    /**
     * 檢查新的訊息和目前快去中最後一則訊息，是否完全一致。
     * 如果一致應該丟棄訊息
     */
    isSameWithLastest(message, param) {
      if (!this.cachedInfos.length) {
        return false;
      }
      const lastestCached = this.cachedInfos[this.cachedInfos.length - 1];
      if (lastestCached.message !== message) {
        return false;
      }
      if (param.title !== lastestCached.param.title) {
        return false;
      }
      try {
        if (!param.afterClose && lastestCached.param.afterClose || param.afterClose && !lastestCached.param.afterClose || param.afterClose && lastestCached.param.afterClose && param.afterClose.toString() !== lastestCached.param.afterClose.toString()) {
          return false;
        }
        if (!param.afterConfirm && lastestCached.param.afterConfirm || param.afterConfirm && !lastestCached.param.afterConfirm || param.afterConfirm && lastestCached.param.afterConfirm && param.afterConfirm.toString() !== lastestCached.param.afterConfirm.toString()) {
          return false;
        }
      } catch (error) {
        return false;
      }
      return true;
    }
    setInfo(cached, cacheIndex) {
      if (!this.infoConfirm) {
        return;
      }
      this.infoConfirm.message = cached.message;
      if (cached.param) {
        if (cached.param.title) {
          this.infoConfirm.title = cached.param.title;
        }
        if (this.cachedInfos.length > 1) {
          this.cachedInfos[this.cachedInfos.length - 2].closeSubc.unsubscribe();
        }
      }
      let closeReason = TmModalCloseReason.SUBMIT;
      cached.closeSubc = merge(this.infoConfirm.afterConfirm.pipe(tap(() => {
        closeReason = TmModalCloseReason.SUBMIT;
      })), this.infoConfirm.afterCancel.pipe(tap(() => {
        closeReason = TmModalCloseReason.CLOSE;
      }))).pipe(take(1)).subscribe(() => {
        if (closeReason === TmModalCloseReason.SUBMIT) {
          if (cached.param && cached.param.afterConfirm) {
            cached.param.afterConfirm();
          }
        } else {
          if (cached.param && cached.param.afterClose) {
            cached.param.afterClose();
          }
        }
        this.cachedInfos.splice(cacheIndex, 1);
        if (this.cachedInfos.length > 0) {
          const cIndex = this.cachedInfos.length - 1;
          const nextCachedAlert = this.cachedInfos[cIndex];
          this.setInfo(nextCachedAlert, cIndex);
          this.infoConfirm?.open();
        }
      });
    }
    setPendingDatas() {
      if (this._pendingTitle) {
        this.title = this._pendingTitle;
      }
      if (this._pendingMessage) {
        this.message = this._pendingMessage;
      }
      if (this._pendingOkBtnLabel) {
        this.okBtnLabel = this._pendingOkBtnLabel;
      }
      if (this._pendingCancelBtnLabel) {
        this.cancelBtnLabel = this._pendingCancelBtnLabel;
      }
      if (this._pendingPanelClass) {
        this.panelClass = this._pendingPanelClass;
      }
      if (this._pendingModalConfig) {
        this.modalConfig = this._pendingModalConfig;
      }
    }
    static ɵfac = function ReusableInfoConfirmComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ReusableInfoConfirmComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ReusableInfoConfirmComponent,
      selectors: [["tm-reusable-info-confirm"]],
      viewQuery: function ReusableInfoConfirmComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(InfoConfirmComponent, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.infoConfirm = _t.first);
        }
      },
      inputs: {
        title: "title",
        message: "message",
        okBtnLabel: "okBtnLabel",
        cancelBtnLabel: "cancelBtnLabel",
        panelClass: "panelClass",
        modalConfig: "modalConfig"
      },
      outputs: {
        afterConfirm: "afterConfirm",
        afterCancel: "afterCancel"
      },
      decls: 1,
      vars: 0,
      consts: [[3, "afterConfirm", "afterCancel"]],
      template: function ReusableInfoConfirmComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "tm-info-confirm", 0);
          i0.ɵɵlistener("afterConfirm", function ReusableInfoConfirmComponent_Template_tm_info_confirm_afterConfirm_0_listener() {
            return ctx.afterConfirm.emit();
          })("afterCancel", function ReusableInfoConfirmComponent_Template_tm_info_confirm_afterCancel_0_listener() {
            return ctx.afterCancel.emit();
          });
          i0.ɵɵelementEnd();
        }
      },
      dependencies: [InfoConfirmComponent]
    });
  }
  return ReusableInfoConfirmComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ReusableInfoAlertComponent = /*#__PURE__*/(() => {
  class ReusableInfoAlertComponent extends ReusableInfoConfirmComponent {
    /** 實體的訊息確認窗 */
    set infoConfirm(c) {
      if (c) {
        this._infoConfirm = c;
        this.setPendingDatas();
      }
    }
    get infoConfirm() {
      return this._infoConfirm;
    }
    static ɵfac = /* @__PURE__ */(() => {
      let ɵReusableInfoAlertComponent_BaseFactory;
      return function ReusableInfoAlertComponent_Factory(__ngFactoryType__) {
        return (ɵReusableInfoAlertComponent_BaseFactory || (ɵReusableInfoAlertComponent_BaseFactory = i0.ɵɵgetInheritedFactory(ReusableInfoAlertComponent)))(__ngFactoryType__ || ReusableInfoAlertComponent);
      };
    })();
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ReusableInfoAlertComponent,
      selectors: [["tm-reusable-info-alert"]],
      viewQuery: function ReusableInfoAlertComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(InfoAlertComponent, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.infoConfirm = _t.first);
        }
      },
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 1,
      vars: 0,
      consts: [[3, "afterConfirm", "afterCancel"]],
      template: function ReusableInfoAlertComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "tm-info-alert", 0);
          i0.ɵɵlistener("afterConfirm", function ReusableInfoAlertComponent_Template_tm_info_alert_afterConfirm_0_listener() {
            return ctx.afterConfirm.emit();
          })("afterCancel", function ReusableInfoAlertComponent_Template_tm_info_alert_afterCancel_0_listener() {
            return ctx.afterCancel.emit();
          });
          i0.ɵɵelementEnd();
        }
      },
      dependencies: [InfoAlertComponent]
    });
  }
  return ReusableInfoAlertComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ReusableErrorAlertComponent = /*#__PURE__*/(() => {
  class ReusableErrorAlertComponent extends ReusableInfoConfirmComponent {
    /** 實體的訊息確認窗 */
    set infoConfirm(c) {
      if (c) {
        this._infoConfirm = c;
        this.setPendingDatas();
      }
    }
    get infoConfirm() {
      return this._infoConfirm;
    }
    _pendingShowCopyButton;
    set showCopyButton(s) {
      if (this.infoConfirm) {
        this.infoConfirm.showCopyButton = s;
        this._pendingShowCopyButton = undefined;
      } else {
        this._pendingShowCopyButton = s;
      }
    }
    get showCopyButton() {
      if (this.infoConfirm) {
        return this.infoConfirm.showCopyButton;
      }
      return this._pendingShowCopyButton || false;
    }
    setPendingDatas() {
      super.setPendingDatas();
      if (this._pendingShowCopyButton) {
        this.showCopyButton = this._pendingShowCopyButton;
      }
    }
    open(message, param) {
      const cached = {
        message: message,
        param: param
      };
      this.cachedInfos.push(cached);
      const cIndex = this.cachedInfos.length - 1;
      this.setInfo(cached, cIndex);
      if (this.infoConfirm && this.infoConfirm.modal && !this.infoConfirm.modal.isOpened) {
        this.infoConfirm.open();
      }
    }
    setInfo(cached, cacheIndex) {
      this.infoConfirm.message = cached.message;
      if (cached.param) {
        if (cached.param.title) {
          this.infoConfirm.title = cached.param.title;
        }
        if (cached.param.showCopyTip) {
          this.infoConfirm.showCopyButton = true;
        } else {
          this.infoConfirm.showCopyButton = false;
        }
        if (this.cachedInfos.length > 1) {
          this.cachedInfos[this.cachedInfos.length - 2].closeSubc.unsubscribe();
        }
      }
      let closeReason = TmModalCloseReason.SUBMIT;
      cached.closeSubc = merge(this.infoConfirm.afterConfirm.pipe(tap(() => {
        closeReason = TmModalCloseReason.SUBMIT;
      })), this.infoConfirm.afterCancel.pipe(tap(() => {
        closeReason = TmModalCloseReason.CLOSE;
      }))).pipe(take(1)).subscribe(() => {
        if (closeReason === TmModalCloseReason.SUBMIT) {
          if (cached.param && cached.param.afterConfirm) {
            cached.param.afterConfirm();
          }
        } else {
          if (cached.param && cached.param.afterClose) {
            cached.param.afterClose();
          }
        }
        this.cachedInfos.splice(cacheIndex, 1);
        if (this.cachedInfos.length > 0) {
          const cIndex = this.cachedInfos.length - 1;
          const nextCachedAlert = this.cachedInfos[cIndex];
          this.setInfo(nextCachedAlert, cIndex);
          this.infoConfirm.open();
        }
      });
    }
    static ɵfac = /* @__PURE__ */(() => {
      let ɵReusableErrorAlertComponent_BaseFactory;
      return function ReusableErrorAlertComponent_Factory(__ngFactoryType__) {
        return (ɵReusableErrorAlertComponent_BaseFactory || (ɵReusableErrorAlertComponent_BaseFactory = i0.ɵɵgetInheritedFactory(ReusableErrorAlertComponent)))(__ngFactoryType__ || ReusableErrorAlertComponent);
      };
    })();
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ReusableErrorAlertComponent,
      selectors: [["tm-reusable-error-alert"]],
      viewQuery: function ReusableErrorAlertComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(ErrorAlertComponent, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.infoConfirm = _t.first);
        }
      },
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 1,
      vars: 0,
      consts: [[3, "afterConfirm", "afterCancel"]],
      template: function ReusableErrorAlertComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "tm-error-alert", 0);
          i0.ɵɵlistener("afterConfirm", function ReusableErrorAlertComponent_Template_tm_error_alert_afterConfirm_0_listener() {
            return ctx.afterConfirm.emit();
          })("afterCancel", function ReusableErrorAlertComponent_Template_tm_error_alert_afterCancel_0_listener() {
            return ctx.afterCancel.emit();
          });
          i0.ɵɵelementEnd();
        }
      },
      dependencies: [ErrorAlertComponent]
    });
  }
  return ReusableErrorAlertComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let GlobalModule = /*#__PURE__*/(() => {
  class GlobalModule {
    static forRoot() {
      return {
        ngModule: GlobalModule,
        providers: [GlobalComponentService]
      };
    }
    static ɵfac = function GlobalModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GlobalModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: GlobalModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, MatDialogModule, MatSnackBarModule, MatProgressBarModule, MatButtonModule]
    });
  }
  return GlobalModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class IGlobalComponent {}
const isSupportObjectFit = () => {
  return 'objectFit' in document.documentElement.style;
};
function isNullOrUndefined(o) {
  return typeof o === 'undefined' || o === null;
}
/** (瀏覽器端) 檢查設備是否為疑動觸控裝置 */
const checkIsMobile = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/.test(window.navigator.userAgent) || checkIsIphone() || checkIsIpad();
};
/** (瀏覽器端) 檢查設備是否為 iphone */
function checkIsIphone() {
  if (window['MSStream']) {
    return false;
  }
  if (window.navigator.platform) {
    return /iPhone/.test(window.navigator.platform);
  } else {
    return /iPhone/.test(window.navigator.userAgent);
  }
}
/** (瀏覽器端) 檢查設備是否為 ipad|ipod */
function checkIsIpad() {
  if (window['MSStream']) {
    return false;
  }
  if (window.navigator.platform) {
    return /iPad|iPod/.test(window.navigator.platform) || window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1;
  } else {
    return /iPad|iPod/.test(window.navigator.userAgent) || /Mac/.test(window.navigator.userAgent) && window.navigator.maxTouchPoints > 1;
  }
}
/** (瀏覽器端) 檢查設備是否為 Mac 電腦 */
function checkIsMacDesktop() {
  if (window['MSStream']) {
    return false;
  }
  if (window.navigator.platform) {
    return window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints <= 1;
  } else {
    return /Mac/.test(window.navigator.userAgent) && window.navigator.maxTouchPoints <= 1;
  }
}
/** (瀏覽器端) 檢查設備是否為 IOS 作業系統裝置 */
function isIOS() {
  return checkIsIphone() || checkIsIpad() || checkIsMacDesktop();
}
/** 檢查是否為觸控螢幕裝置 */
function checkIsTouchMobile() {
  let hasTouchScreen = false;
  const navigator = window.navigator;
  if ('maxTouchPoints' in navigator) {
    hasTouchScreen = navigator.maxTouchPoints > 0;
  } else if ('msMaxTouchPoints' in navigator) {
    hasTouchScreen = navigator['msMaxTouchPoints'] > 0;
  } else {
    const mQ = window['matchMedia'] && window['matchMedia']('(pointer:coarse)');
    if (mQ && mQ.media === '(pointer:coarse)') {
      hasTouchScreen = !!mQ.matches;
    } else if ('orientation' in window) {
      hasTouchScreen = true; // deprecated, but good fallback
    } else {
      // Only as a last resort, fall back to user agent sniffing
      const UA = navigator.userAgent;
      hasTouchScreen = /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(UA) || /\b(Android|Windows Phone|iPad|iPod)\b/i.test(UA);
    }
  }
  return hasTouchScreen;
}
/**
 * 動態載入 CSS 樣式表到文檔中。
 *
 * @param document - 要插入 CSS 樣式表的文檔物件。
 * @param renderer - 用於與 DOM 互動的渲染器服務。
 * @param parentEl - 要將 CSS 樣式表插入到的父元素。
 * @param styleName - CSS 樣式表的唯一識別符。
 * @param path - CSS 樣式表的路徑。
 * @param crossOrigin - (可選) 是否要以跨源方式載入 CSS 樣式表。預設為 false。
 */
function loadLazyCssFile(document, renderer, parentEl, styleName, path, refChild, crossOrigin = false) {
  if (document.getElementById(styleName)) {
    return;
  }
  // 在文檔中尋找 nonce
  let findNonce = null;
  const sts = document.querySelectorAll('style');
  for (let i = 0; i < sts.length && !findNonce; i++) {
    const sc = sts[i];
    const nonce = sc['nonce'] || sc.getAttribute('nonce');
    if (nonce) {
      findNonce = nonce;
    }
  }
  const styleElement = renderer.createElement('link');
  renderer.setAttribute(styleElement, 'id', `${styleName}`);
  if (findNonce) {
    renderer.setAttribute(styleElement, 'nonce', `${findNonce}`);
  }
  renderer.setAttribute(styleElement, 'href', `${path}`);
  renderer.setAttribute(styleElement, 'rel', `stylesheet`);
  if (crossOrigin) {
    renderer.setAttribute(styleElement, 'crossOrigin', `anonymous`);
    // FIXME: from moj frontend
    // renderer.setAttribute(styleElement, 'integrity', `sha256-${sha256(path)}`);
  }
  let body = parentEl.closest('body');
  if (isNullOrUndefined(body)) {
    body = document.body;
  }
  const head = body.previousElementSibling;
  renderer.insertBefore(head, styleElement, refChild ? refChild : head.querySelector('link[rel="canonical"]'));
}
/**
 * 動態載入 JavaScript 文件到文檔中。
 *
 * @param document - 將插入腳本的文檔對象。
 * @param renderer - 用於與 DOM 交互的渲染器服務。
 * @param scriptName - 腳本的唯一標識符。
 * @param path - 要加載的 JavaScript 文件的路徑。
 * @param useDefer - （可選）確定腳本是否應該使用 `defer` 屬性加載。
 * @param crossOrigin - （可選）確定腳本是否應該使用 `crossorigin` 屬性加載。默認為 `false`。
 */
function loadLazyJsFile(document, renderer, scriptName, path, useDefer, crossOrigin = false) {
  if (document.getElementById(scriptName)) {
    return;
  }
  // 在文檔中尋找 nonce
  let findNonce = null;
  const scs = document.querySelectorAll('script');
  for (let i = 0; i < scs.length && !findNonce; i++) {
    const sc = scs[i];
    const nonce = sc['nonce'] || sc.getAttribute('nonce');
    if (nonce) {
      findNonce = nonce;
    }
  }
  const script = renderer.createElement('script');
  renderer.setAttribute(script, 'id', `${scriptName}`);
  renderer.setAttribute(script, 'type', `text/javascript`);
  if (findNonce) {
    renderer.setAttribute(script, 'nonce', `${findNonce}`);
  }
  renderer.setAttribute(script, 'src', `${path}`);
  renderer.setAttribute(script, 'async', ``);
  if (useDefer) {
    renderer.setAttribute(script, 'defer', ``);
  }
  if (crossOrigin) {
    renderer.setAttribute(script, 'crossOrigin', `anonymous`);
    // FIXME: from moj frontend
    // renderer.setAttribute(script, 'integrity', `sha256-${sha256(path)}`);
  }
  // 用 document 塞在 server 端不會有作用, 但沒關係這個在 client 端再執行就好
  // 用 parentEl.closest('body').previousSiblingsElement appendChild 也沒用 (但 insertBefore 沒試過)
  renderer.appendChild(document.head, script);
}
function closestPolifill() {
  if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
  }
  if (!Element.prototype.closest) {
    Element.prototype.closest = function (s) {
      let el = this;
      do {
        if (typeof s === 'string' && Element.prototype.matches.call(el, s)) {
          return el;
        } else if (typeof s === 'object' && el === s) {
          return el;
        }
        el = el.parentElement || el.parentNode;
      } while (el !== null && el.nodeType === 1);
      return null;
    };
  }
}
/** 可餵入 HTMLElement做目標比對的 closest 方法 */
const closest = (el, s) => {
  let target = el;
  do {
    if (typeof s === 'string') {
      if (Element.prototype.matches.call(el, s)) {
        return el;
      }
    } else if (s instanceof HTMLElement) {
      if (el === s) {
        return el;
      }
    }
    target = target instanceof Node && (target['parentElement'] || target['parentNode']) || null;
  } while (target !== null && target instanceof Node && target['nodeType'] && target['nodeType'] === 1);
  return null;
};
/** 將表格的查詢參數轉換成查 API 用的查詢參數 */
function transferTableParams2HttpListParams(queryParam) {
  let params = {};
  if (queryParam.limit) {
    params['size'] = `${queryParam.limit}`;
  }
  if (queryParam.filter) {
    params['sfilterize'] = `${queryParam.filter}`;
  }
  if (queryParam.search) {
    params['search'] = `${queryParam.search}`;
  }
  if (queryParam.limit && (queryParam.offset || queryParam.offset === 0)) {
    params['page'] = `${queryParam.offset / queryParam.limit}`;
  }
  if (queryParam.sort && queryParam.order) {
    params['sort'] = `${queryParam.sort},${queryParam.order}`;
  }
  if (queryParam.query) {
    const query = JSON.parse(queryParam.query);
    const keys = Object.keys(query);
    if (keys.length !== 0) {
      for (const k of keys) {
        if (!isNullOrUndefined(query[k])) {
          params[k] = query[k];
        }
      }
    }
  }
  return params;
}
/** 將物件中未定義的值轉成 null */
function transferObjNullVal(customSearchEntity) {
  for (let keys = Object.keys(customSearchEntity), i = 0; i < keys.length; i++) {
    const key = keys[i];
    if (typeof customSearchEntity[key] === 'undefined') {
      customSearchEntity[key] = null;
    }
  }
}
/** 將物件中未定義或空值移除 */
function rmObjNullorUndefinedVal(customSearchEntity) {
  for (let keys = Object.keys(customSearchEntity), i = 0; i < keys.length; i++) {
    const key = keys[i];
    if (customSearchEntity[key] === null || customSearchEntity[key] === undefined) {
      delete customSearchEntity[key];
    }
  }
}
/** 打亂陣列排序 */
function randomData(data) {
  // tslint:disable-next-line: only-arrow-functions
  data.sort(function () {
    return 0.5 - Math.random();
  });
  return data;
}
function removeUrlQueryParam(url) {
  let queryIndex = url.indexOf('?');
  if (queryIndex === -1) {
    queryIndex = url.indexOf(';');
  }
  if (queryIndex > 0) {
    url = url.substring(0, queryIndex);
  }
  return url;
}
/**
 * 解析 URL 中的查詢參數，並將其轉換為一個對象。
 *
 * 此函數可以處理兩種格式的查詢參數：
 * 1. 標準格式：以 '?' 開始，參數間用 '&' 分隔。
 * 2. 分號格式：以 ';' 開始，參數間用 '&' 分隔。
 *
 * 注意：如果存在重複的參數名，後面的值會覆蓋前面的值。
 *
 * @param {string} url - 要解析的 URL，通常是 location.href
 * @returns {Object} 包含所有查詢參數的對象。鍵是參數名，值是參數值。
 *
 * @example
 * // 假設 url 是 "https://example.com?param1=value1&param2=value2"
 * const params = parseQueryParams(url);
 * // 結果: { param1: 'value1', param2: 'value2' }
 *
 * @example
 * // 處理分號格式
 * const url = "https://example.com;param1=value1&param2=value2"
 * const params = parseQueryParams(url);
 * // 結果: { param1: 'value1', param2: 'value2' }
 */
function parseQueryPqrams(url) {
  let queryParamSatrtIndex = url.indexOf('?');
  const queryParam = {};
  if (queryParamSatrtIndex !== -1) {
    const urlQueryParam = url.slice(queryParamSatrtIndex + 1, url.length);
    urlQueryParam.split('&').forEach(qps => {
      const a = qps.split('=');
      queryParam[a[0]] = a[1];
    });
    url = url.replace('?' + urlQueryParam, '');
  }
  queryParamSatrtIndex = url.indexOf(';');
  if (queryParamSatrtIndex !== -1) {
    const urlQueryParam = url.slice(queryParamSatrtIndex + 1, url.length);
    urlQueryParam.split('&').forEach(qps => {
      const a = qps.split('=');
      queryParam[a[0]] = a[1];
    });
  }
  return queryParam;
}
/**
 * 解析 JWT (JSON Web Token) 並返回其載荷（payload）部分。
 *
 * 注意：這個函數只解析 token，不驗證其簽名或有效性。
 *
 * @param {string} accessToken - 完整的 JWT token 字符串。
 * @returns {Object} 解析後的 JWT payload 對象。
 *
 * @example
 * const token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c';
 * const payload = parseJWTtoken(token);
 * console.log(payload);
 * // 輸出: { sub: '1234567890', name: 'John Doe', iat: 1516239022 }
 *
 * @throws {Error} 如果 token 格式不正確或解析失敗。
 */
function parseJWTtoken(accessToken) {
  const base64Url = accessToken.split('.')[1];
  let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  switch (base64.length % 4) {
    case 0:
      break;
    case 2:
      base64 += '==';
      break;
    case 3:
      base64 += '=';
      break;
    default:
      break;
  }
  const jwtPayloadStr = decodeURIComponent(escape(atob(base64)));
  return JSON.parse(jwtPayloadStr);
}
const fadeInOutAnimation = trigger('fadeInOut', [state('true', style({
  visibility: 'inherit',
  opacity: 1
})), state('false', style({
  visibility: 'hidden',
  opacity: 0
})), transition('* => *', animate('0.5s'))]);
/** 轉換貨幣字符成數字 */
function currencyToNum(currency) {
  return Number(currency.toString().replace(/[^0-9.-]+/g, ''));
}
/** 轉換數字成貨幣字符 */
function numCurrency(num) {
  return Intl.NumberFormat('en-US').format(num);
}
/** 回傳範圍內的數值陣列 */
function range(end, start = 0, step = 1, includeEnd = true) {
  const size = (end - start) / step + (includeEnd ? 1 : 0);
  return Array.from(Array(size)).map((_, i) => start + i * step);
}
/**
 * Function that returns element rectangle & position (width, height, top, left)
 * @param element - Element which position & rectangle are returned
 */
function getRectangle(element) {
  const width = Math.max(element.offsetWidth, element.clientWidth, element.scrollWidth);
  const height = Math.max(element.offsetHeight, element.clientHeight, element.scrollHeight);
  let top = 0;
  let left = 0;
  do {
    top += element.offsetTop || 0;
    left += element.offsetLeft || 0;
    element = element.offsetParent;
  } while (element);
  return {
    top,
    left,
    width,
    height
  };
}

/*
 * Public API Surface of global
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ErrorAlertComponent, GlobalComponentService, GlobalModule, IGlobalComponent, IndeterminateProgressBarComponent, InfoAlertComponent, InfoConfirmComponent, ReusableErrorAlertComponent, ReusableInfoAlertComponent, ReusableInfoConfirmComponent, TmModalBodyComponent, TmModalCloseReason, TmModalComponent, TmModalData, TmModalFooterComponent, TmModalHeaderComponent, checkIsIpad, checkIsIphone, checkIsMacDesktop, checkIsMobile, checkIsTouchMobile, closest, closestPolifill, currencyToNum, fadeInOutAnimation, getRectangle, isIOS, isNullOrUndefined, isSupportObjectFit, loadLazyCssFile, loadLazyJsFile, numCurrency, parseJWTtoken, parseQueryPqrams, randomData, range, removeUrlQueryParam, rmObjNullorUndefinedVal, transferObjNullVal, transferTableParams2HttpListParams };
